import React, { useState, useEffect } from 'react';
import Header from '../../components/ui/Header';
import BreadcrumbTrail from '../../components/ui/BreadcrumbTrail';
import OrganizationChart from './components/OrganizationChart';
import DepartmentDetails from './components/DepartmentDetails';
import DepartmentSearch from './components/DepartmentSearch';
import QuickContactCard from './components/QuickContactCard';
import { supabase } from '../../utils/supabaseClient';

const OrganizationStructure = () => {
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [filteredDepartments, setFilteredDepartments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [departments, setDepartments] = useState([]);
  const [reloadKey, setReloadKey] = useState(0);

  // Toggle data source: false = legacy in-file structure (old layout), true = Supabase
  const USE_DB = false;

  // Legacy departments (original structure for the old chart)
  const LEGACY_DEPARTMENTS = [
    {
      id: 1,
      legacyKey: 'district_office',
      name: 'ที่ทำการปกครองอำเภอเทิง',
      fullName: 'ที่ทำการปกครองอำเภอเทิง จังหวัดเชียงราย',
      head: 'นายเอนก ปันทะยม',
      headPosition: 'นายอำเภอเทิง',
      level: 1,
      parentId: null,
      icon: 'Building2',
      staffCount: 26,
      responsibilities: [
        'บริหารงานทั่วไปของอำเภอ',
        'กำกับดูแลการปฏิบัติงานของหน่วยงานในสังกัด',
        'ประสานงานกับหน่วยงานราชการและเอกชน',
        'ให้บริการประชาชนในเขตพื้นที่'
      ],
      services: [
        'รับจดทะเบียนพาณิชย์',
        'ออกใบอนุญาตประกอบกิจการ',
        'รับเรื่องร้องเรียน',
        'บริการข้อมูลข่าวสาร'
      ],
      contact: {
        phone: '053-795-345',
        email: 'districtthoeng@gmail.com',
        extension: '101',
        hours: 'จันทร์-ศุกร์ 08:30-16:30 น.'
      }
    },
    {
      id: 2,
      legacyKey: 'general_admin',
      name: 'กลุ่มงานบริหารงานปกครอง',
      fullName: 'กลุ่มงานบริหารงานปกครอง ที่ทำการปกครองอำเภอเทิง',
      head: 'นายกฤษฎา ชัยยา',
      headPosition: 'หัวหน้ากลุ่มงานบริหารงานปกครอง',
      level: 2,
      parentId: 1,
      icon: 'Settings',
      staffCount: 12,
      responsibilities: [
        'บริหารงานบุคลากรและการเงิน',
        'จัดการระบบสารสนเทศ',
        'ดูแลอาคารสถานที่และยานพาหนะ',
        'จัดทำแผนงานและงบประมาณ'
      ],
      services: [
        'บริการข้อมูลบุคลากร',
        'จัดการเอกสารราชการ',
        'ประชาสัมพันธ์ข้อมูลข่าวสาร',
        'บริการห้องประชุม'
      ],
      contact: {
        phone: '053-795-345',
        email: 'districtthoeng@gmail.com',
        extension: '201',
        hours: 'จันทร์-ศุกร์ 08:30-16:30 น.'
      }
    },
    {
      id: 3,
      legacyKey: 'registry_idcard',
      name: 'กลุ่มงานทะเบียนและบัตร',
      fullName: 'กลุ่มงานทะเบียนและบัตร',
      head: 'นายบรรพต โพธิ์มา',
      headPosition: 'หัวหน้ากลุ่มงานทะเบียนและบัตร',
      level: 3,
      parentId: 2,
      icon: 'IdCard',
      staffCount: 7,
      responsibilities: [
        'งานทะเบียบราษฎรและบัตรประชาชน',
        'ให้บริการออกบัตรและปรับปรุงข้อมูลทะเบียน',
        'อำนวยความสะดวกประชาชนด้านงานทะเบียน'
      ],
      services: [
        'ทำ/ต่ออายุ/แก้ไขข้อมูลบัตรประชาชน',
        'บริการคัดและรับรองทะเบียนราษฎร'
      ],
      contact: {
        phone: '053-795-883',
        email: 'districtthoeng@gmail.com',
        extension: '211',
        hours: 'จันทร์-ศุกร์ 08:30-16:30 น.'
      }
    },
    {
      id: 4,
      legacyKey: 'security',
      name: 'กลุ่มงานความมั่นคง',
      fullName: 'กลุ่มงานความมั่นคง',
      head: 'นายกฤตชัย  สุวรรณ์',
      headPosition: 'ปลัดอำเภอ(จพง.ปค.ชำนาญการ)',
      level: 3,
      parentId: 2,
      icon: 'Shield',
      staffCount: 6,
      responsibilities: [
        'รักษาความสงบเรียบร้อยและความมั่นคงภายใน',
        'ประสานงานด้านการป้องกันและบรรเทาสาธารณภัย'
      ],
      services: [
        'งานความมั่นคงและกิจการความสงบเรียบร้อย'
      ],
      contact: {
        phone: '053-795-345',
        email: 'districtthoeng@gmail.com',
        extension: '311',
        hours: 'จันทร์-ศุกร์ 08:30-16:30 น.'
      }
    },
    {
      id: 5,
      legacyKey: 'finance',
      name: 'กลุ่มงานการเงินและบัญชี',
      fullName: 'กลุ่มงานการเงินและบัญชี',
      head: 'นางรำพรรณ หายหัตถี',
      headPosition: 'จพง.การเงินและบัญชี',
      level: 3,
      parentId: 2,
      icon: 'Calculator',
      staffCount: 3,
      responsibilities: [
        'จัดทำงบประมาณและควบคุมการเบิกจ่าย',
        'จัดทำรายงานทางการเงินและบัญชี'
      ],
      services: [
        'รับชำระค่าธรรมเนียมและออกใบเสร็จ',
        'ให้คำปรึกษาด้านการเงิน'
      ],
      contact: {
        phone: '053-795-345',
        email: 'districtthoeng@gmail.com',
        extension: '321',
        hours: 'จันทร์-ศุกร์ 08:30-16:30 น.'
      }
    },
    {
      id: 6,
      legacyKey: 'district_office_section',
      name: 'สำนักงานอำเภอ',
      fullName: 'สำนักงานอำเภอ',
      head: 'นางลัดดา สมหนองบัว',
      headPosition: 'จพง.ปค.ชำนาญการ',
      level: 3,
      parentId: 2,
      icon: 'Building',
      staffCount: 4,
      responsibilities: [
        'งานธุรการ งานสารบรรณ และอำนวยการทั่วไป',
        'อำนวยความสะดวกการบริการประชาชน'
      ],
      services: [
        'งานสารบรรณและประชาสัมพันธ์',
        'บริการข้อมูลทั่วไป'
      ],
      contact: {
        phone: '053-795-345',
        email: 'districtthoeng@gmail.com',
        extension: '331',
        hours: 'จันทร์-ศุกร์ 08:30-16:30 น.'
      }
    },
    {
      id: 7,
      legacyKey: 'administration_group',
      name: 'กลุ่มงานบริหารงานปกครอง',
      fullName: 'กลุ่มงานบริหารงานปกครอง',
      head: 'นายพัฒณพงษ์  นาคะพงษ์',
      headPosition: 'จพง.ปค.ชำนาญการ',
      level: 3,
      parentId: 2,
      icon: 'Users',
      staffCount: 4,
      responsibilities: [
        'กำกับดูแลองค์กรปกครองส่วนท้องถิ่นและการปกครองท้องที่',
        'งานทะเบียนครอบครัวและสัญชาติ'
      ],
      services: [
        'งานกำนันผู้ใหญ่บ้านและอปพร.'
      ],
      contact: {
        phone: '053-795-345',
        email: 'districtthoeng@gmail.com',
        extension: '341',
        hours: 'จันทร์-ศุกร์ 08:30-16:30 น.'
      }
    },
    {
      id: 8,
      legacyKey: 'dhamrongtham_center',
      name: 'กลุ่มงานอำนวยความเป็นธรรมศูนย์ดำรงธรรมอำเภอเทิง',
      fullName: 'กลุ่มงานอำนวยความเป็นธรรม ศูนย์ดำรงธรรมอำเภอเทิง',
      head: 'นางสาวกฤษณา สมวุฒิ',
      headPosition: 'จพง.ปค.ปฏิบัติการ',
      level: 3,
      parentId: 2,
      icon: 'Scale',
      staffCount: 1,
      responsibilities: [
        'รับเรื่องร้องเรียน ร้องทุกข์ และให้ความช่วยเหลือประชาชน',
        'ประสานส่วนราชการเพื่อแก้ไขปัญหา'
      ],
      services: [
        'ศูนย์ดำรงธรรมอำเภอเทิง'
      ],
      contact: {
        phone: '053-795-345',
        email: 'info@thoeng.go.th',
        extension: '351',
        hours: 'จันทร์-ศุกร์ 08:30-16:30 น.'
      }
    }
  ];

  // Load departments from selected source
  useEffect(() => {
    const loadDepartments = async () => {
      setIsLoading(true);
      if (!USE_DB) {
        // Keep legacy layout but overlay name/head/position from DB (if exists)
        const legacy = LEGACY_DEPARTMENTS;
        try {
          const { data, error } = await supabase
            .from('departments')
            .select('name, head, head_position, level, icon, legacy_key');
          if (error) throw error;
          const rows = Array.isArray(data) ? data : [];
          const normalize = (s) => (s || '').toString().replace(/\s+/g, '').trim();
          const merged = legacy.map((ld) => {
            const matchByIcon = rows.find((r) => (r?.icon || '') === (ld?.icon || ''));
            const matchByLegacyKey = rows.find((r) => (r?.legacy_key || '') === (ld?.legacyKey || ''));
            const matchByName = rows.find((r) => normalize(r?.name).includes(normalize(ld?.name)) || normalize(ld?.name).includes(normalize(r?.name)));
            const matchByLevel = rows.find((r) => r?.level === ld?.level);
            const db = matchByLegacyKey || matchByIcon || matchByName || matchByLevel || null;
            return {
              ...ld,
              name: db?.name ?? ld.name,
              head: db?.head ?? ld.head,
              headPosition: db?.head_position ?? ld.headPosition,
            };
          });
          // Sort: level asc, then keep legacy order
          const rank = new Map(legacy.map((d, i) => [d.legacyKey || d.icon || d.name, i]));
          const sorted = [...merged].sort((a, b) => {
            const la = Number.isFinite(a.level) ? a.level : 999;
            const lb = Number.isFinite(b.level) ? b.level : 999;
            if (la !== lb) return la - lb;
            const ra = rank.get(a.legacyKey || a.icon || a.name) ?? 0;
            const rb = rank.get(b.legacyKey || b.icon || b.name) ?? 0;
            return ra - rb;
          });
          setDepartments(sorted);
          setFilteredDepartments(sorted);
        } catch (err) {
          console.error('Load departments (overlay) error:', err);
          setDepartments(legacy);
          setFilteredDepartments(legacy);
        }
        setIsLoading(false);
        return;
      }
      const { data, error } = await supabase
        .from('departments')
        .select('*')
        .order('level', { ascending: true });
      if (error) {
        console.error('Load departments error:', error);
        setDepartments([]);
        setFilteredDepartments([]);
      } else {
        const mapped = (data || []).map((d) => ({
          id: d.id,
          name: d.name,
          fullName: d.full_name,
          head: d.head,
          headPosition: d.head_position,
          level: d.level,
          parentId: d.parent_id,
          icon: d.icon || 'Building2',
          staffCount: d.staff_count || 0,
          responsibilities: Array.isArray(d.responsibilities) ? d.responsibilities : [],
          services: Array.isArray(d.services) ? d.services : [],
          contact: {
            phone: d.phone || '',
            email: d.email || '',
            extension: d.extension || '',
            hours: d.hours || ''
          }
        }));
        setDepartments(mapped);
        setFilteredDepartments(mapped);
      }
      setIsLoading(false);
    };
    loadDepartments();
  }, [reloadKey]);

  // Keep filtered list in sync when departments change (if not actively filtered)
  useEffect(() => {
    setFilteredDepartments(departments);
  }, [departments]);

  const handleDepartmentSelect = (department) => {
    setSelectedDepartment(department);
  };

  const handleFilteredResults = (filtered) => {
    setFilteredDepartments(filtered);
  };

  const handleClearSearch = () => {
    setFilteredDepartments(departments);
    setSelectedDepartment(null);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background">
        <Header />
        <div className="max-w-7xl mx-auto px-4 lg:px-6 py-6">
          <div className="animate-pulse">
            <div className="h-8 bg-muted rounded w-1/3 mb-6"></div>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              <div className="lg:col-span-2">
                <div className="h-96 bg-muted rounded-lg"></div>
              </div>
              <div className="space-y-4">
                <div className="h-64 bg-muted rounded-lg"></div>
                <div className="h-48 bg-muted rounded-lg"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <div className="max-w-7xl mx-auto px-4 lg:px-6 py-6">
        <BreadcrumbTrail />
        
        {/* Page Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-foreground mb-2">
            โครงสร้างองค์กร
          </h1>
          <p className="text-muted-foreground">
            ข้อมูลโครงสร้างองค์กร หน่วยงาน และบุคลากรของที่ทำการปกครองอำเภอเทิง
          </p>
          <div className="mt-3">
            <button
              className="text-sm px-3 py-1 rounded border border-border hover:bg-muted"
              onClick={() => setReloadKey((k) => k + 1)}
            >
              รีเฟรชข้อมูล
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Main Content */}
          <div className="lg:col-span-2 space-y-6">
            {/* Search Component */}
            <DepartmentSearch
              departments={departments}
              onFilteredResults={handleFilteredResults}
              onClearSearch={handleClearSearch}
            />

            {/* Organization Chart */}
            <OrganizationChart
              departments={filteredDepartments}
              onDepartmentSelect={handleDepartmentSelect}
              selectedDepartment={selectedDepartment}
            />
          </div>

          {/* Sidebar */}
          <div className="space-y-6">
            {/* Department Details */}
            <DepartmentDetails department={selectedDepartment} allDepartments={departments} />

            {/* Quick Contact Card */}
            <QuickContactCard departments={departments} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrganizationStructure;